// Main Helper for components
//
// Path: app/js/helpers/componentsHelper.js
// Compare this snippet from app/js/EditorMain.js:

import {autoSave} from "../common/autoSave.js";
import l10n from "../../lang/locallang";

export const componentsHelper = {

    /*
    * method for adding unique id to assets
    * @param element - element for adding attribute
    * @param img_id - id of image
    * @param section_id - id of section
    * @param asset_type - type of asset (image, video, audio)
    * */
    setAssetUniqueID: (element = null, img_id, section_id, asset_type) => {
        // take lesson id from url parameter "topic"
        const urlParams = new URLSearchParams(window.location.search);
        const lesson_id = urlParams.get('topic') ? urlParams.get('topic') : '';
        // make base64 string from string
        let random_number = Math.floor(Math.random() * 90000) + 10000; // random number from 10000 to 99999
        //console.log(`${asset_type}-${lesson_id}-${section_id}-${img_id}-${random_number}`)
        let unique_id = btoa(`${asset_type}-${lesson_id}-${section_id}-${random_number}`);
        if (element) {
            element.setAttribute('data-asset-id', unique_id);
        } else {
            return unique_id;
        }
    },

    optimizeImage: (img = null, base64Data, isBase = false) => {
        //console.log('optimizeImage')
        //console.log(base64Data)

        let quality = 0.9;
        let maxWidth = 1900;
        let maxHeight = 1200;
        let image = new Image();
        let result = '';
        image.src = base64Data;
        if (base64Data.startsWith('data:image')) {
            image.onload = function () {
                let originalWidth = image.width;
                let originalHeight = image.height;
                let originalWeight = base64Data.length;
                // weight in kilobytes
                if (originalWidth > maxWidth && originalHeight > maxHeight || originalWeight > 900000) {
                    let aspectRatio = originalWidth / originalHeight;
                    let newWidth, newHeight;
                    if (aspectRatio > 1) {
                        newWidth = maxWidth;
                        newHeight = maxWidth / aspectRatio;
                    } else {
                        newHeight = maxHeight;
                        newWidth = maxHeight * aspectRatio;
                    }
                    let canvas = document.createElement('canvas');
                    let ctx = canvas.getContext('2d');
                    // Set canvas dimensions to match the image
                    canvas.width = newWidth;
                    canvas.height = newHeight;
                    // Draw the image onto the canvas
                    ctx.drawImage(image, 0, 0, newWidth, newHeight);
                    // Convert the canvas content back to base64 (jpeg format)
                    let optimizedBase64 = canvas.toDataURL('image/jpeg', quality); // Adjust quality as needed
                    // Set the image source to the optimized base64
                    console.log(optimizedBase64)
                    if (img !== null) {
                        console.log('set optimizedBase64')
                        img.src = optimizedBase64;
                    } else {
                        console.log('return optimizedBase64')
                        // optimizedBase64 to string
                        result = optimizedBase64;

                    }
                } else {
                    if (img !== null) {
                        console.log('set base64Data')
                        img.src = base64Data;
                    } else {
                        console.log('return optimizedBase64 2')
                        result = base64Data;
                    }
                }

            };
        }
        return result;
    },


    /*
    * method for detecting image source - base64 or url
    * @param imageSrc - source of image
     */
    detectImageSource: (imageSrc) => {
        if (imageSrc.startsWith('data:image')) {
            return 'base64';
        } else if (imageSrc.startsWith('http') || imageSrc.startsWith('www')) {
            return 'url';
        } else {
            return 'unknown';
        }
    },

    // Update l10n with defaultContent elements
    updateLocalization: (defaultContent) => {
        const lang = document.documentElement.lang;

        if (defaultContent.hasOwnProperty(lang)) {
            const items = defaultContent[lang];
            for (const key in items) {
                if (items.hasOwnProperty(key)) {
                    if (!l10n[key]) {
                        l10n[key] = {};
                    }

                    l10n[key] = {...l10n[key], ...items[key]};
                }
            }
        }
    },
    // Shuffle array items for public view of matching items
    shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]]; // ES6 destructuring swap
        }
    },

    shuffleQuestionsAndMatchings(data) {
        // Create a deep copy of the data array to avoid modifying the original
        let newData = JSON.parse(JSON.stringify(data));
        const questions = newData.map(item => item.question);
        const matchings = newData.map(item => item.matching);

        // Shuffle both arrays
        this.shuffleArray(questions);
        this.shuffleArray(matchings);

        // Assign shuffled questions and matchings back to the new data
        newData.forEach((item, index) => {
            item.question = questions[index];
            item.matching = matchings[index];
        });

        return newData;
    },
    shuffleObject(cards) {
        let keys = Object.keys(cards);
        let shuffled = {};
        this.shuffleArray(keys);
        keys.forEach(key => {
            shuffled[key] = cards[key];
        });
        return shuffled;
    }
}

/**
 * Makes the toolbar sticky only when the content exceeds the viewport height.
 * @param {string} toolbarSelector - CSS selector of the toolbar element.
 */
export function manageStickyToolbar(toolbarSelector) {
    const toolbar = document.querySelector(toolbarSelector);
    const mainContent = document.querySelector('main'); // Assuming main content is in a <main> tag
    const toolbarInitialPosition = toolbar.offsetTop;

    function updateToolbarPosition() {
        const viewportHeight = window.innerHeight;
        const contentHeight = document.body.scrollHeight;

        if (contentHeight <= viewportHeight) {
            // Content fits within the viewport; ensure toolbar stays at the bottom
            toolbar.classList.remove('sticky');
            toolbar.style.position = 'static';
        } else {
            // Content exceeds viewport; make the toolbar sticky
            const scrollPosition = window.scrollY;

            if (scrollPosition + viewportHeight < toolbarInitialPosition) {
                toolbar.classList.add('sticky');
                toolbar.style.position = 'fixed';
                toolbar.style.bottom = '0';
                toolbar.style.width = '100%'; // Optional: to prevent resizing
            } else {
                toolbar.classList.remove('sticky');
                toolbar.style.position = 'static';
            }
        }
    }

    // Attach event listeners
    window.addEventListener('scroll', updateToolbarPosition);
    window.addEventListener('resize', updateToolbarPosition);

    // Initial check
    updateToolbarPosition();
}
